import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function generateHeadingMetaOptions(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/generate_heading_meta_options`)
}

export function getHeadingMetaLock(pageId) {
  return axios.get(`/ajax/website_pages/${pageId}/heading_meta_lock`)
}

export function lockTitleTag(pageId, titleTag) {
  return axios.post(`/ajax/website_pages/${pageId}/lock_title_tag`, { title_tag: titleTag })
}

export function lockMetaDescription(pageId, metaDescription) {
  return axios.post(`/ajax/website_pages/${pageId}/lock_meta_description`, { meta_description: metaDescription })
}

export function lockH1(pageId, h1) {
  return axios.post(`/ajax/website_pages/${pageId}/lock_h1`, { h1 })
}

export function lockHeadingStructure(pageId, headings) {
  return axios.post(`/ajax/website_pages/${pageId}/lock_heading_structure`, { headings })
}

export function verifyHeadingKeywords(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/verify_heading_keywords`)
}

export function lockTargets(pageId, selectedKeywords) {
  return axios.post(`/ajax/website_pages/${pageId}/lock_targets`, { selected_keywords: selectedKeywords })
}

export function unlockStep(pageId, step) {
  return axios.post(`/ajax/website_pages/${pageId}/unlock_step`, { step })
}
